import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { Cell as ActionCell } from '../Cell';
import { SideModal } from '../../components/SideModal';
import { VehicleHeaderV2Design } from '../../../Vehicles/components/VehicleHeaderV2Design';
import { FINCompanyCard } from '../../../Companies/components/FinCompanyCard';
import { FIN_facturerenModalBody } from '../../components/FinFacturerenModalBody/FinFacturerenModalBody';
import { FIN_facturerenModal } from '../../components/FinFacturerenEditInvoiceModal/FinFacturerenModal';
import { InvoiceFinalizationSection } from '../../components/InvoiceFinalizationSection';
import { DeleteInvoice } from '../../../Invoices/components/DeleteInvoice/DeleteInvoice';
import { toggleKanbanCompanyModal } from '../../actions';
import { getCurrentRestBpm, updateInvoiceOutgoingBpm } from '../../../Invoices/actions';
import { selectCompany } from '../../../Companies/selectors';
import { selectKanbanCompanyToggle } from '../../selectors';
import {
  GET_CURRENT_REST_BPM,
  REQUEST_EXACT_EXPORT_INVOICE,
  REQUEST_INVOICE,
  REQUEST_INVOICE_EMAIL,
} from '../../../Invoices/constants';
import { REQUEST_COMPANY } from '../../../Companies/constants';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import cn from 'classnames';
import styles from './FIN.module.css';

const Container = styled.div`
  h2 {
    font-size: 16px;
    text-transform: uppercase;
  }

  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class FIN_factureren_2Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    // this.props.getCurrentRestBpm(this.vehicle?.id);
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  toggle() {
    return this.props.toggleModal(this.vehicle?.id);
  }

  applyDisable() {
    return this.props.workCompany || this.props.workInvoice || this.props.workMailing;
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell className={styles.cell}>
        <Container>
          {this.props.isShowModal?.isShow && this.props.isShowModal?.entityId == vehicle?.id && (
            <SideModal className={styles.sideContainer}>
              <div className={styles.buttonClose}>
                <button
                  onClick={this.toggle.bind(this)}
                  type="button"
                  className={cn('btn-close', styles.buttonCl)}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <WithVehicle vehicle_id={this.vehicle.id} loader>
                <VBox>
                  <h2>{this.props.action?.functionName}</h2>
                  <VBox right>
                    <div className={styles.boxButtons}>
                      <div className={styles.buttonView}>
                        <ButtonComponent
                          style={'ButtonSoftPrimary'}
                          onClick={this.tofn(`/invoices/${this.vehicle.outgoing_invoice}`)}
                        >
                          <View /> {this.lbl('vehicle.details.view_outgoingInvoice')}
                        </ButtonComponent>
                      </div>

                      {this.props.workFinalize ? (
                        <Loader small />
                      ) : (
                        <InvoiceFinalizationSection
                          className={styles.buttonInvoiceFinalizationSection}
                          invoice_id={this.vehicle?.outgoing_invoice}
                          FIN_kanban_modal
                        />
                      )}

                      <DeleteInvoice className={styles.buttonDeleteInvoice} invoiceId={this.vehicle?.outgoing_invoice} />
                    </div>

                    <VehicleHeaderV2Design className={styles.VehicleHeaderV2Design} wide vehicle={this.vehicle} />
                    <FINCompanyCard companyId={this.vehicle?.invoice_outgoing_company_id} />
                  </VBox>
                  <FIN_facturerenModalBody invoiceId={this.vehicle?.outgoing_invoice} />
                  <FIN_facturerenModal invoiceId={this.vehicle?.outgoing_invoice} vehicle={this.vehicle} />
                </VBox>
                {/* <div className="pane"></div> */}
              </WithVehicle>
            </SideModal>
          )}
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.toggle.bind(this)}>
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
        </Container>
      </ActionCell>
    );
  }
}

FIN_factureren_2Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    workFinalize: selectWork(REQUEST_EXACT_EXPORT_INVOICE),
    workCompany: selectWork(REQUEST_COMPANY),
    workInvoice: selectWork(REQUEST_INVOICE),
    workMailing: selectWork(`${REQUEST_INVOICE_EMAIL}-${ownProps.cell.vehicle?.outgoing_invoice}`),
    workBpm: selectWork(GET_CURRENT_REST_BPM),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    company: selectCompany(ownProps.cell.vehicle?.invoice_outgoing_company_id),
    isShowModal: selectKanbanCompanyToggle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    toggleModal(vehicleId) {
      dispatch(toggleKanbanCompanyModal(vehicleId));
    },
    getCurrentRestBpm(vehicleId) {
      dispatch(getCurrentRestBpm(vehicleId));
    },
    updateInvoiceOutgoingBpm(invoiceId, value, callback) {
      dispatch(updateInvoiceOutgoingBpm(invoiceId, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FIN_factureren_2 = compose(withConnect, withRouter)(FIN_factureren_2Comp);
